import { PLAY_JOIN_PATH, PLAY_PATHS } from '@words-happen/app-urls';
import type { AccountTab } from '@words-happen/screens';

export const ROUTES = {
  dashboard: PLAY_PATHS.home,
  welcome: PLAY_PATHS.welcome,
  play: '/play',
  daily: '/daily',
  /** The account area's Profile tab. Public: guests see a prompt to create an account or sign in. */
  profile: '/profile',
  /** The account area's Settings tab. Public: guests change device settings, and see account settings locked. */
  settings: '/settings',
  /** The games list (WH-155). Signed in only. */
  games: '/games',
  /** Invite a friend or quick match. Signed in only. */
  newGame: '/games/new',
  /** A board game (WH-156); the ID is the last segment (`gamePath`). Signed in only. */
  game: '/games/:id',
  /** The invite landing page; the code is the last segment (`joinGamePath`). Public: guests are asked to sign in. */
  join: `${PLAY_JOIN_PATH}/:code`,
} as const;

/** The board game screen for a game. */
export const gamePath = (gameId: string): string => `/games/${encodeURIComponent(gameId)}`;

/** The route of each account tab. */
export const ACCOUNT_TAB_ROUTES: Record<AccountTab, string> = {
  profile: ROUTES.profile,
  settings: ROUTES.settings,
};
